module.exports = __webpack_public_path__ + "img/hr.c5fcbdc5.jpg";